import axiosHttp from '@/utilities/axios-http'
import apiConfig from '@/config/api-config'

class BaseCrudService {
  resource
  resourcePath

  constructor(resource) {
    this.resource = resource
    this.resourcePath = `${apiConfig.API_BASE_URL}/${apiConfig.API_PATH}/${this.resource}`
  }

  index = () => {
    return axiosHttp.get(this.resourcePath)
  }

  show = id => {
    return axiosHttp.get(`${this.resourcePath}/${id}`)
  }

  store = payload => {
    return axiosHttp.post(this.resourcePath, payload)
  }

  update = (id, payload) => {
    return axiosHttp.put(`${this.resourcePath}/${id}`, payload)
  }

  delete = id => {
    return axiosHttp.delete(`${this.resourcePath}/${id}`)
  }
}

export default BaseCrudService
